import { useEffect, type ReactNode } from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';

export function V3Dialog(props: {
  readonly id: string;
  readonly title: string;
  readonly onClose: () => void;
  readonly children: ReactNode;
}) {
  const { onClose } = props;

  useEffect(() => {
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="v3-modal-backdrop"
      onClick={onClose}
    >
      <div
        className="v3-modal"
        style={{ maxWidth: 640, maxHeight: 'calc(100dvh - 24px)' }}
        role="dialog"
        aria-modal="true"
        aria-labelledby={`${props.id}-t`}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="v3-dlg-head">
          <h2
            id={`${props.id}-t`}
            className="v3-modal-title"
            style={{ overflowWrap: 'anywhere' }}
          >
            {props.title}
          </h2>
          <button
            type="button"
            className="v3-btn ghost"
            aria-label="Schliessen"
            onClick={onClose}
          >
            <XMarkIcon
              width={20}
              height={20}
            />
          </button>
        </div>
        <div className="v3-dlg-body">{props.children}</div>
      </div>
    </div>
  );
}
